import { defineStore } from 'pinia';
import { getBeusPlanList, getBaPlanList } from '@/api'

interface Plan {
  _id: string,
  planName: string,
  planNumber: number,
  price: number,
  planGroup?: string
}

export const usePlanStore = defineStore('plan', {
  state: () => ({
    beusPlanData: [] as Plan[],
    baPlanData: [] as Plan[]
  }),
  actions: {
    processPlanData(planList: Plan[]): Plan[] {
      return planList
        // .filter((plan: Plan) => plan.price > 0)
        .map((plan: Plan) => ({
          _id: plan._id,
          planName: plan.planName,
          planNumber: plan.planNumber,
          price: plan.price,
          planGroup: plan.planGroup
        }));
    },
    async fetchPlans(): Promise<void> {
      try {
        const [beusPlan, baPlan] = await Promise.all([
          getBeusPlanList(),
          getBaPlanList(),
        ]);

        this.beusPlanData = this.processPlanData(beusPlan.result);
        this.baPlanData = this.processPlanData(baPlan.result);
      } catch (error) {
        console.error('Failed to fetch plans:', error);
      }
    }
  }
});